export default __webpack_public_path__ + "media/images/services-13-450x304-1230d12c27d818041e5192dda4a0ce2e.jpg";